import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AddCommentDialogData } from '../add-comment-dialog/add-comment-dialog-data';
import { AddCommentDialogComponent } from '../add-comment-dialog/add-comment-dialog.component';

@Injectable()
export class AddCommentDialogService {
    constructor(private dialog: MatDialog) { }

    matDialogRef: MatDialogRef<AddCommentDialogComponent>;

    open(addCommentDialogData: AddCommentDialogData) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.width = '30em';
        matDialogConfig.data = addCommentDialogData;
        matDialogConfig.disableClose = true;
        matDialogConfig.hasBackdrop = true;
        this.matDialogRef = this.dialog.open(AddCommentDialogComponent, matDialogConfig);
    }

    confirmed(): Observable<any> {
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
